import React, { useState, useEffect } from "react";
import DischargeLogTable from "./DischargeLogTable";
import { useVoyageContextV2 } from "../../Contexts/VoyageContextV2";
import { useCompanyContext } from "../../Contexts/CompanyContext";
import VoyageCargoInfoTable from "../pumplogging/VoyageCargoInfoTable";
import AvgEtc from "./AvgEtc";
import { getSelectedCargo, getSelectedTrip } from "../../utils/voyageSelection";

const DischargeLog = () => {
  const {
    selectedTripId,
    selectedCargoIndex,
    currentVoyage,
    isVoyageReadOnly,
    updateTripCargo,
  } = useVoyageContextV2();

  const { companyLogo } = useCompanyContext();

  const trip = getSelectedTrip(currentVoyage, selectedTripId) || {};
  const cargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );
  const dischargingLogRates = cargo?.dischargingLogRates;
  // States
  const [avgRate, setAvgRate] = useState(0);
  const [lastAvgRate, setLastAvgRate] = useState(0);
  const [etcAvg, setEtcAvg] = useState(0);
  const [etcCurrent, setEtcCurrent] = useState(0);
  const [manifolds, setManifolds] = useState("");
  const [connectionSize, setConnectionSize] = useState("");
  const [isLocked, setIsLocked] = useState(true);

  // Synka states med V2-data
  useEffect(() => {
    const rates = dischargingLogRates || {};
    setAvgRate(rates.avgRate || 0);
    setLastAvgRate(rates.lastAvgRate || 0);
    setEtcAvg(rates.etcAvg || 0);
    setEtcCurrent(rates.etcCurrent || 0);
    setManifolds(rates.manifolds || "");
    setConnectionSize(rates.connectionSize || "");
    setIsLocked(Boolean(rates.manifolds));
  }, [dischargingLogRates]);

  const handleLock = async () => {
    if (isVoyageReadOnly) return;
    if (!isLocked) {
      await saveManifoldsAndConnection();
    }
    setIsLocked(!isLocked);
  };

  const saveManifoldsAndConnection = async () => {
    if (!currentVoyage || !cargo?.cargoId) return;

    await updateTripCargo(
      cargo.cargoId,
      {
        dischargingLogRates: {
          ...(cargo.dischargingLogRates || {}),
        manifolds,
        connectionSize,
        avgRate,
        lastAvgRate,
        etcAvg,
        etcCurrent,
        },
      },
      { summary: "Updated discharge log rates" }
    );
  };

  return (
    <>
      <VoyageCargoInfoTable
        currentVoyage={currentVoyage}
        trip={trip}
        cargo={cargo}
        avgRate={avgRate}
        lastAvgRate={lastAvgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
        manifolds={manifolds}
        connectionSize={connectionSize}
        setManifolds={setManifolds}
        setConnectionSize={setConnectionSize}
        isLocked={isLocked}
        handleLock={handleLock}
        readOnly={isVoyageReadOnly}
        selectedTripId={selectedTripId}
        selectedCargoIndex={selectedCargoIndex}
        companyLogo={companyLogo}
        isLoadLog={false}
      />

      <AvgEtc
        avgRate={avgRate}
        lastAvgRate={lastAvgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
      />

      <DischargeLogTable
        lastAvgRate={lastAvgRate}
        avgRate={avgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
        setAvgRate={setAvgRate}
        setLastAvgRate={setLastAvgRate}
        setEtcAvg={setEtcAvg}
        setEtcCurrent={setEtcCurrent}
      />
    </>
  );
};

export default DischargeLog;
